import { Navigate, useLocation } from "react-router-dom";
import { resolveExperienceId } from "../lib/experienceCompanies";
import { normalizePortfolioSlug } from "../lib/portfolioRoutes";

const EXACT: Record<string, string> = {
  "/what-design-i-do": "/about",
  "/ux-design-resume": "/experience",
  "/portfolio": "/ux-portfolio",
  "/contact-your-designer": "/contact",
  "/faq/code": "/faq/development",
  "/search": "/search",
};

/** Old /portfolio/ short segments → canonical /ux-portfolio/... */
const LEGACY_PORTFOLIO_SLUGS: Record<string, string> = {
  productdesign: "product-design",
  "product-design": "product-design",
  mobile: "mobile-design",
  "mobile-design": "mobile-design",
  webdesign: "web-design",
  "web-design": "web-design",
  motion: "motion-design",
  "motion-design": "motion-design",
  identity: "branding-and-identity",
  "branding-and-identity": "branding-and-identity",
};

function normalizePath(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

function legacyPortfolioRedirect(pathname: string): string | null {
  const match = pathname.match(/^\/portfolio\/([^/]+)/i);
  if (!match) return null;
  const segment = match[1].toLowerCase();
  const canonical = LEGACY_PORTFOLIO_SLUGS[segment] ?? normalizePortfolioSlug(segment);
  if (canonical) return `/ux-portfolio/${canonical}`;
  return "/ux-portfolio";
}

function experienceRedirect(pathname: string): string | null {
  const match = pathname.match(/^\/ux-design-resume\/([^/]+)/i);
  if (!match) return null;
  const slug = match[1];
  const id = resolveExperienceId(slug);
  return id ? `/experience/${id}` : null;
}

export function LegacyRedirect(): JSX.Element {
  const { pathname } = useLocation();
  const path = normalizePath(pathname);

  const exact = EXACT[path];
  if (exact) return <Navigate to={exact} replace />;

  const company = experienceRedirect(pathname);
  if (company) return <Navigate to={company} replace />;

  if (path.startsWith("/what-design-i-do")) {
    return <Navigate to="/about" replace />;
  }

  const portfolio = legacyPortfolioRedirect(path);
  if (portfolio) return <Navigate to={portfolio} replace />;

  if (path.startsWith("/portfolio")) {
    return <Navigate to="/ux-portfolio" replace />;
  }

  if (path.startsWith("/faq/code")) {
    return <Navigate to="/faq/development" replace />;
  }

  return <Navigate to="/404" replace />;
}
